import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { StrictMode, useState } from "react";
import { createBrowserRouter } from "react-router";
import { RouterProvider } from "react-router/dom";
import { Toaster } from "./components/atoms/Sonner.tsx";
import { routesTree } from "./routes-tree.tsx";
import "./styles/index.css";

const AppProviders = () => {
  const routes = routesTree();

  const [router] = useState(() => {
    return createBrowserRouter(routes);
  });

  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            retry: (failureCount, error) => {
              const status = (error as AxiosError).response?.status;
              // Don't retry client errors (4xx) — e.g. a 419 logout or a 401/403.
              if (status && status >= 400 && status < 500) return false;
              return failureCount < 3;
            },
          },
        },
      }),
  );

  return (
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        {/* a logout's navigation must land before the dashboards' role redirect reacts to the cleared session */}
        <RouterProvider router={router} useTransitions={false} />
        <Toaster />
      </QueryClientProvider>
    </StrictMode>
  );
};

export default AppProviders;
